import ConfiguredAddons from './ConfiguredAddons';

export default ConfiguredAddons;
